import React, { useState } from "react";
import * as Accordion from "@radix-ui/react-accordion";

const accordionRootClasses = `
    w-[90%] rounded-lg bg-brand-slate flex flex-col h-[full]
`;

const AccordionComponentMobilePremium = () => {
  const [isSMOpen, setIsSMOpen] = useState(false);
  const [isWPOpen, setIsWPOpen] = useState(false);

  return (
    <div className="flex flex-col w-full items-center justify-center mt-10">
      <Accordion.Root className={accordionRootClasses} type="multiple">
        <Accordion.Item
          value="item-1"
          className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
        >
          <Accordion.Trigger
            className="
                    group flex flex-1 h-[120px] items-center 
                    justify-between px-5 text-[15px]
                    hover:bg-brand-slate/40"
            onClick={() => setIsSMOpen(!isSMOpen)}
          >
            <div className="flex w-[50px] items-start mr-2">
              {isSMOpen ? (
                <span
                  className="icon-[ic--baseline-minus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              ) : (
                <span
                  className="icon-[ic--baseline-plus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              )}
            </div>

            <div className="grid grid-cols-2">
              <div className="justify-start items-start text-start">
                <p className="font-bold">Social Media</p>
                <p className="font-light text-slate-300 text-sm -mt-2">
                  Mass delete your content from social media platforms.
                </p>
              </div>
              <div className="justify-start items-start text-start ml-5">
                <p className="font-bold text-brand-blue">Premium</p>
                <p className="font-light text-slate-300 text-sm -mt-2">Starting @ $95.88/ Yearly</p>
              </div>
            </div>
          </Accordion.Trigger>

          <Accordion.Content
            className="
                    overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
          >
            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Twitter</p>
              </div>
              <div className="items-start ml-3">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Reddit</p>
              </div>
              <div className="items-start ml-3">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Discord</p>
              </div>
              <div className="items-start ml-2.5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Facebook</p>
              </div>
              <div className="items-start ml-2.5">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Steam</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Imgur</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Deviantart</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Pinterest</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Tumblr</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">My Anime List</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Disqus</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Gyazo</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Bumble</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Bluesky</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Mastodon</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Flickr</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Yelp</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[ic--sharp-check]"
                  style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
                ></span>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>

      <Accordion.Root className={accordionRootClasses + " mt-10"} type="multiple">
        <Accordion.Item
          value="item-2"
          className="overflow-hidden bg-brand-slate first:mt-0 first:rounded-lg last:rounded-lg cursor-pointer w-full hover:bg-brand-slate/40"
        >
          <Accordion.Trigger
            className="
                    group flex flex-1 h-[120px] items-center 
                    justify-between px-5 text-[15px]
                    hover:bg-brand-slate/40"
            onClick={() => setIsWPOpen(!isWPOpen)}
          >
            <div className="flex w-[50px] items-start mr-2">
              {isSMOpen ? (
                <span
                  className="icon-[ic--baseline-minus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              ) : (
                <span
                  className="icon-[ic--baseline-plus]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              )}
            </div>

            <div className="grid grid-cols-2">
              <div className="justify-start items-start text-start">
                <p className="font-bold">Work and productivity</p>
                <p className="font-light text-slate-300 text-sm -mt-2">
                  Mass delete your content from work platforms.
                </p>
              </div>
              <div className="justify-start items-start text-start ml-5">
                <p className="font-bold text-brand-blue">Premium</p>
                <p className="font-light text-slate-300 text-sm -mt-2">Starting @ $95.88/ Yearly</p>
              </div>
            </div>
          </Accordion.Trigger>

          <Accordion.Content
            className="
                    overflow-hidden bg-brand-slate text-[15px] text-white data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
          >
            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Slack</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">LinkedIn</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Skype</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">StackExchange</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Email</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Wordpress</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Quora</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Github</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>

            <div className="ml-3 h-[1px] w-full bg-slate-500 opacity-15"></div>

            <div className="grid grid-cols-2 ml-[4rem]">
              <div className="flex items-start">
                <p className="text-start text-slate-300 opacity-75">Medium</p>
              </div>
              <div className="mt-3 ml-1">
                <span
                  className="icon-[system-uicons--cross]"
                  style={{ width: "2rem", height: "2rem" }}
                ></span>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  );
};

export default AccordionComponentMobilePremium;
